import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { ProblemReframe } from '../components/ProblemReframe';
import { ProtocolTable } from '../components/ProtocolTable';
import { WhatsIncluded } from '../components/WhatsIncluded';
import { Results } from '../components/Results';
import { WhoItsFor } from '../components/WhoItsFor';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function LandingPage() {
  useEffect(() => {
    // Check if pixel is already initialized to prevent duplicate
    if (window.fbq && window.fbq.loaded) {
      return;
    }
    // Standard Meta Pixel initialization
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    // Create and load the script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Insert script
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
    // Initialize and track PageView (queued, will fire when script loads)
    window.fbq('init', '1460293155735606');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full overflow-x-hidden selection:bg-[#0d9488] selection:text-white" data-id="element-244">
      <Hero data-id="element-245" />
      <PainPoints data-id="element-246" />
      <ProblemReframe data-id="element-247" />
      <ProtocolTable data-id="element-248" />
      <WhatsIncluded data-id="element-249" />
      <Results data-id="element-250" />
      <WhoItsFor data-id="element-251" />
      <FinalCTA data-id="element-252" />
      <Footer data-id="element-253" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-254">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1460293155735606&ev=PageView&noscript=1" alt="" data-id="element-255" />
      </noscript>
    </main>;
}